app.controller('BrowseEditController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $scope.edit_state_model = null;

    $scope.combination_limit = 99999;

    $scope.edit_initialized = false;

    $scope.is_editing = false;
    $scope.editing_model_id = null;
    $scope.editing_combination_model_index = -1;
    $scope.show_edit_response = false
    $scope.edit_cart_response = null;

    $scope.show_cart_did_update = false;

    $scope.resetEdit = function () {

        resetEditingState();

        $scope.edit_state_model = $rootScope.service.order_edit.createEditStateModel();
        $scope.edit_initialized = true;
    }


    const EditPropertyModel = function () {
        this.edit_navigation_ids = {};
        this.current_choice_id = null
    }

    $scope.editPropertyModel = null;

    $scope.editColour = function (combinationModelIndex) {

        const editingCombinationModel = $scope.edit_state_model.combination_models[combinationModelIndex];
        if (!editingCombinationModel) {
            return;
        }

        $scope.show_edit_response = false;
        $scope.is_editing = true;
        $scope.editing_model_id = "colour_route";
        $scope.editing_combination_model_index = combinationModelIndex;

        $scope.editPropertyModel = new EditPropertyModel();
        $scope.editPropertyModel.edit_navigation_ids.request_range_id = editingCombinationModel.request_range_id;
        $scope.editPropertyModel.edit_navigation_ids.site_range_id = editingCombinationModel.site_range_id;

        $scope.editPropertyModel.current_choice_id = editingCombinationModel.selected_colour_id ? editingCombinationModel.selected_colour_id : editingCombinationModel.initial_colour_id;
    }

    $scope.editStyle = function (combinationModelIndex) {

        const editingCombinationModel = $scope.edit_state_model.combination_models[combinationModelIndex];
        if (!editingCombinationModel) {
            return;
        }
        $scope.editing_combination_model_index = combinationModelIndex;

        $scope.show_edit_response = false;
        $scope.is_editing = true;
        $scope.editing_model_id = "style_route";

        $scope.editPropertyModel = new EditPropertyModel();
        $scope.editPropertyModel.edit_navigation_ids.request_range_id = editingCombinationModel.request_range_id;
        $scope.editPropertyModel.edit_navigation_ids.site_range_id = editingCombinationModel.site_range_id;
        $scope.editPropertyModel.edit_navigation_ids.colour_id = editingCombinationModel.selected_colour_id ? editingCombinationModel.selected_colour_id : editingCombinationModel.initial_colour_id;

        $scope.editPropertyModel.current_choice_id = editingCombinationModel.selected_style_id ? editingCombinationModel.selected_style_id : editingCombinationModel.initial_style_id;
    }


    $scope.onPropertySelected = function (choiceID) {

        const editingModelID = $scope.editing_model_id;
        const combinationModelIndex = $scope.editing_combination_model_index;

        resetEditingState()

        const combinationModel = $scope.edit_state_model.combination_models[combinationModelIndex];
        if (!combinationModel) {
            return;
        }
        let doEditStyle = false;
        if (editingModelID !== "style_route") {
            const colourModel = $rootScope.factory.colour.getModel({site_range_id: combinationModel.site_range_id});
            const colourChoice = colourModel.choices[choiceID];
            if (!colourChoice) {
                return;
            }
            combinationModel.selected_colour_id = choiceID;
            combinationModel.selected_colour_choice = colourChoice;

            if (!combinationModel.style_hidden) {
                doEditStyle = true;
            }
        } else {
            const styleModel = $rootScope.factory.style.getModel({
                site_range_id: combinationModel.site_range_id,
                colour_id: combinationModel.colour_id
            });
            const styleChoice = styleModel.choices[choiceID];
            if (!styleChoice) {
                return;
            }
            combinationModel.selected_style_id = choiceID;
            combinationModel.selected_style_choice = styleChoice;
        }
        if (doEditStyle) {
            $scope.editStyle(combinationModelIndex);
        } else {
            $scope.editing_combination_model_index = combinationModelIndex;
            handleEditResponse();
        }
    }

    function handleEditResponse() {
        $scope.show_edit_response = true
        $scope.edit_cart_response = null;
        const combinationModel = $scope.edit_state_model.combination_models[$scope.editing_combination_model_index];
        if (!combinationModel.selected_colour_id) {
            combinationModel.selected_colour_id = combinationModel.initial_colour_id;
            combinationModel.selected_colour_choice = combinationModel.initial_colour_choice;
        }
        if (!combinationModel.selected_style_id) {
            combinationModel.selected_style_id = combinationModel.initial_style_id;
            combinationModel.selected_style_choice = combinationModel.initial_style_choice;
        }
        if (combinationModel.selected_colour_id === combinationModel.initial_colour_id && combinationModel.selected_style_id === combinationModel.initial_style_id) {
            return;
        }
        const editCartResponse = new $rootScope.service.order_edit.EditCartResponseModel();
        editCartResponse.can_not_replace_tally = combinationModel.can_not_edit_tally;

        for (let i = 0; i < combinationModel.can_not_edit_order_lines.length; i++) {
            const cartLine = combinationModel.can_not_edit_order_lines[i];
            editCartResponse.apply_cart_line_errors.push({
                name: cartLine.description,
                quantity: cartLine.quantity,
                error: "Cannot be edited"
            })
        }


        const originalLines = [];
        const replacementLines = [];
        for (let i = 0; i < combinationModel.order_lines.length; i++) {
            const cartLine = combinationModel.order_lines[i];
            originalLines.push(cartLine);
            const replacementLine = JSON.parse(JSON.stringify(cartLine));
            replacementLine.colour = combinationModel.selected_colour_id;
            replacementLine.style = combinationModel.selected_style_id;
            replacementLine.state_ids.colour_id = combinationModel.selected_colour_id;
            replacementLine.state_ids.style_id = combinationModel.selected_style_id;
            replacementLines.push(replacementLine);
        }

        $rootScope.service.order_edit.validateReplaceCart(originalLines, replacementLines, combinationModel.can_not_edit_order_lines, [], editCartResponse);


        $scope.edit_cart_response = editCartResponse;
    }

    function resetEditingState() {

        $scope.is_editing = false;
        $scope.editing_model_id = null;
        $scope.editing_combination_model_index = -1;
        $scope.show_edit_response = false
        $scope.edit_cart_response = null;
        $scope.show_cart_did_update = false;
    }


    $scope.onEditSolutionCartClick = function (solutionID) {

        const model = $scope.edit_state_model.edit_solution_cart_models[solutionID];
        const routeOptions = model ? model.route_options : null;
        if (!routeOptions) {
            return;
        }
        let isSameRoute = true;
        let collectionProductFound = false;
        for (let i = 0; i < model.state_list.length; i++) {
            const modelID = model.state_list[i].model_id;
            if (modelID === "collection_product") {
                collectionProductFound = true;
                break;
            }
            const choiceID = model.state_list[i].choice_id;
            const state = $rootScope.navigation_model.state_list[i]
            if (choiceID && (!state || state.choice_id !== choiceID)) {
                isSameRoute = false;
            }
        }
        if (!collectionProductFound) {
            return;
        }
        $rootScope.service.menu.edit_solution_cart_called = true;
        $rootScope.service.menu.setCartVisible(false)
        if (isSameRoute) {
            $rootScope.$broadcast("edit_solution_cart_called");
        }
        $state.go(routeOptions.route, routeOptions.options)
    }


    $scope.confirmEditResponse = function (removeUnmatched) {

        const combinationModel = $scope.edit_state_model.combination_models[$scope.editing_combination_model_index];

        const replacementCart = !removeUnmatched ? $scope.edit_cart_response.replacement_cart : $scope.edit_cart_response.matched_replacement_cart;

        $rootScope.service.order_edit.applyReplacementCart(replacementCart, combinationModel.unrelated_cart, $scope.edit_cart_response, function (success) {
            if (success) {
                $scope.show_cart_did_update = true;
            }
        });
    }


    $rootScope.service.order.requireInitializedCurrentOrder(function () {
        $scope.resetEdit()
        $rootScope.$on('current_order_replaced', $scope.resetEdit)
    });


}])